
import { Component, Vue } from 'vue-property-decorator';
import { namespace } from "vuex-class";

import "@/store/modules/forms/form1";
const form1State = namespace("Form1");

import "@/store/modules/forms/form4";
const form4State = namespace("Form4");

import StepNumber from "@/components/utils/StepNumber.vue";
import { form1DataInfoType, form1QualificationInfoType } from '@/types/Information/Form1';

import ApplicationsProcessModal from '@/components/process/JourneyMap/components/AppRightToAppeal/ApplicationsProcessModal.vue'

@Component({
    components:{
        StepNumber,
        ApplicationsProcessModal
    }
})
export default class Form1QualifyQuestions extends Vue {

    @form1State.State
    public currentNoticeOfAppealId: string;

    @form1State.State
    public form1Info: form1DataInfoType;

    @form4State.Action
    public UpdateCurrentNoticeOfApplicationId!: (newCurrentNoticeOfApplicationId: string) => void

    dataReady = false;
    tribunalCase = false;
    stepStyle = "font-size: 2rem;";
    qualificationInfo = {} as form1QualificationInfoType;

    showApplicationsWindow=false

    update = 0;

    state = {
        selfRepresenting: null,
        appealingProvincialCourtOrder: null,        
        insideTimeLimit: null, 
        appealingBankruptcy: null, 
        appealingFeesWaived: null,
        appealingSupremeCourtMaster: null,
        appealingSupremeCourtOrder:null,
        appealingScFlaDivorce:null,
        appealTribunal: null
    }   

    responseOptions = [
        {text: 'Yes', value: true},
        {text: 'No', value: false}
    ];

    mounted(){        
        this.dataReady = false;
        this.tribunalCase = false;
        this.qualificationInfo = {} as form1QualificationInfoType;
        if (this.currentNoticeOfAppealId && this.form1Info){         
            this.extractData();            
        } else {            
            this.qualificationInfo.selfRepresenting = this.$store.state.Common.userSelfRepresented;
            this.clearStates();
            this.qualificationResponse();
            Vue.nextTick(()=> {
                this.dataReady = true;
            });
        }
    }
    
    public extractData(){
        this.qualificationInfo.selfRepresenting = this.form1Info.selfRepresenting;
        this.qualificationInfo.appealingProvincialCourtOrder = this.form1Info.appealingProvincialCourtOrder;
        this.qualificationInfo.insideTimeLimit = this.form1Info.insideTimeLimit;
        this.qualificationInfo.appealingBankruptcy = this.form1Info.appealingBankruptcy;
        this.qualificationInfo.appealingFeesWaived = this.form1Info.appealingFeesWaived;
        this.qualificationInfo.appealingSupremeCourtMaster = this.form1Info.appealingSupremeCourtMaster;
        this.qualificationInfo.appealingSupremeCourtOrder = this.form1Info.appealingSupremeCourtOrder;
        this.qualificationInfo.appealingScFlaDivorce = this.form1Info.appealingScFlaDivorce;
        this.qualificationInfo.appealTribunal = this.form1Info.appealTribunal;

        this.qualificationResponse();
        
        Vue.nextTick(()=> {
            this.dataReady = true;
        });
    }

    public qualificationResponse(){ 
        this.tribunalCase = this.qualificationInfo.appealTribunal;

        const qualified = this.checkStates()
        this.$emit('disableContinue', !qualified, this.qualificationInfo);          
        this.update++;
    }

    public clearStates(){       
        this.state = {
            selfRepresenting:null,
            appealingProvincialCourtOrder:null,        
            insideTimeLimit:null, 
            appealingBankruptcy:null, 
            appealingFeesWaived:null,
            appealingSupremeCourtMaster:null,
            appealingSupremeCourtOrder:null,
            appealingScFlaDivorce:null,           
            appealTribunal:null
        }         
    }
    
    public checkStates(){       
        this.state.selfRepresenting = (this.qualificationInfo.selfRepresenting == null)? false : null;
        this.state.appealTribunal = (this.qualificationInfo.appealTribunal == null)? false : null; 
        this.state.appealingProvincialCourtOrder = (this.qualificationInfo.appealingProvincialCourtOrder == null)? false : null;
        this.state.appealingBankruptcy = (this.qualificationInfo.appealingBankruptcy == null)? false : null;
        this.state.appealingSupremeCourtMaster = (this.qualificationInfo.appealingSupremeCourtMaster == null)? false : null; 
        this.state.appealingScFlaDivorce = (this.qualificationInfo.appealingScFlaDivorce == null)? false : null;
        this.state.appealingSupremeCourtOrder = (this.qualificationInfo.appealingSupremeCourtOrder == null)? false : null; 
        this.state.insideTimeLimit = (this.qualificationInfo.insideTimeLimit == null)? false : null;
        this.state.appealingFeesWaived = (this.qualificationInfo.appealingFeesWaived == null)? false : null;        
        
        if (this.tribunalCase){
            this.state.appealingProvincialCourtOrder = null;
            this.state.appealingBankruptcy = null;
            this.state.appealingSupremeCourtMaster = null; 
            this.state.appealingScFlaDivorce = null;
            this.state.appealingSupremeCourtOrder = null;
        }
        
        for(const field of Object.keys(this.state)){
            if(this.state[field]==false)
                return false
        }
        return true            
    }    

    public helpText(){
        const content = 'The name given to a decision-making body that has been established by statute which is not a court; for example the Labour Relations Board or the Workers’ Compensation Board.'
        return {title: "<div style='margin: 0;'>" +content+ "</div>"};
    }

    public startNewForm4Document(){
        this.UpdateCurrentNoticeOfApplicationId(null);
        this.$router.push({name: "start-form4" });
    }

    public startNewForm22Document(){
        this.UpdateCurrentNoticeOfApplicationId(null);
        this.$router.push({name: "start-form22" });
    }

}
